// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PacksackSellLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelSell: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelNum: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

    private selectNum = 1;
    private backItem: NormalBackpackI = null;
    private goodsData: normalBackPackSaveI = null;
   
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        let goodsId = this._carryData.goodsId;
        this.goodsData = NormalGameManager._instance.getOneGood(goodsId);
        this.backItem = backPackEventMap()[goodsId];

        if (this._carryData.hideSellPrice) {
            this.labelPrice.node.active = false;
            this.labelSell.string = '确  定';
        }
        this.refreshNum();
    }

    refreshNum() {
        let allPrice = this.selectNum * this.backItem.sellPrice;
        this.labelNum.string = data_control.getNumberFormat(this.selectNum);
        this.labelPrice.string = '总售价：' + data_control.getNumberFormat(allPrice);
    }

    adjustNum() {
        this.selectNum = Math.max(1, Math.min(this.selectNum, this.goodsData.num));
        this.refreshNum();
    }

    onClickAdd() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.selectNum++;
        this.adjustNum();
    }

    onClickSub() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNum--;
        this.adjustNum();
    }

    onClickMin() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNum = 1;
        this.adjustNum();
    }

    onClickMax() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNum = this.goodsData.num;
        this.adjustNum();
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
        if (this._carryData.confirm) {
            this._carryData.confirm(this.selectNum);
        }
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
        if (this._carryData.cancel) {
            this._carryData.cancel();
        }
    }

    // update (dt) {}
}
